const API = process.env.REACT_APP_BACKEND_URL;
export const BOARD_API = `${API}/api/board`;

export const getToken = () => localStorage.getItem("board_token");
export const setToken = (t) => localStorage.setItem("board_token", t);
export const clearToken = () => localStorage.removeItem("board_token");

export const boardFetch = async (path, opts = {}) => {
  const headers = { ...(opts.headers || {}) };
  const token = getToken();
  if (token) headers.Authorization = `Bearer ${token}`;
  const options = { ...opts, headers };
  if (opts.json !== undefined) {
    headers["Content-Type"] = "application/json";
    options.body = JSON.stringify(opts.json);
    delete options.json;
  }
  const res = await fetch(`${BOARD_API}${path}`, options);
  if (res.status === 401) {
    clearToken();
    if (!window.location.pathname.endsWith("/board/login")) window.location.assign("/board/login");
    throw new Error("Nicht angemeldet");
  }
  if (!res.ok) {
    const err = await res.json().catch(() => ({ detail: "Ein Fehler ist aufgetreten" }));
    throw new Error(typeof err.detail === "string" ? err.detail : "Ein Fehler ist aufgetreten");
  }
  const ct = res.headers.get("content-type") || "";
  return ct.includes("application/json") ? res.json() : res;
};

export const fileUrl = (docId) => `${BOARD_API}/documents/${docId}/file?auth=${encodeURIComponent(getToken() || "")}`;
export const boardPackUrl = (cid) => `${BOARD_API}/companies/${cid}/board-pack.pdf?auth=${encodeURIComponent(getToken() || "")}`;
